'use client'

import { useEffect } from 'react'
import { getAnalytics } from '@/lib/analytics/client'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => { getAnalytics().captureException(error) }, [error])
  return (
    <html>
      <body className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center">
        <h2 className="text-lg font-semibold">Something went wrong</h2>
        <button onClick={() => reset()} className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground">
          Try again
        </button>
      </body>
    </html>
  )
}
